import { render, staticRenderFns } from "./VuesticChat.vue?vue&type=template&id=4ee811f0&scoped=true&"
import script from "./VuesticChat.vue?vue&type=script&lang=js&"
export * from "./VuesticChat.vue?vue&type=script&lang=js&"
import style0 from "./VuesticChat.vue?vue&type=style&index=0&id=4ee811f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee811f0",
  null
  
)

component.options.__file = "VuesticChat.vue"
export default component.exports